import styled from 'styled-components'

import { Input as InputUnstyled } from '../Input'

export const Input = styled(InputUnstyled)`
  margin-bottom: 4px;
`
